import { AppService, Types as AppTypes } from '../App/Services/AppService';
import { AccessControlExportedTypes } from './AccessControlExportedTypes';
import { AppServices } from '@singularsystems/neo-core'
import { IUsersApiClient } from './ApiClients/UsersApiClient';

// Symbols specific to this module.
const AccessControlTypes = {
    ApiClients: {
        UsersApiClient: new AppServices.ServiceIdentifier<IUsersApiClient>("ApiClient.UsersApiClient")
    },
    Services: {
        ...AccessControlExportedTypes.Services,
    }
}

// Merged symbols from app for convenience.
const Types = {
    ...AppTypes,
    AccessControl: {
        ...AccessControlTypes
    }
}

export { AppService, Types, AccessControlTypes }